export enum TableAction {
    Create,
    Edit,
    Delete,
    ToDo,
    InProgress,
    Done,
    Checked,
    Unchecked,
    AssignedEmployee,
    UnassignedEmployee,
    Closed,
    SetProject
}
